import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/views/home'


const FichaNoticia = () => import('@/components/views/ficha-noticia')

const Contacto = () => import('@/components/views/contacto')
const TrabajaConNosotros = () => import('@/components/views/trabaja-con-nosotros')

const fiestahoy = () => import('@/components/views/fiesta-hoy');
const fiestamundo = () => import('@/components/views/fiesta-por-el-mundo');
const historia = () => import('@/components/views/la-historia-de-fiesta');
const metelefiesta = () => import('@/components/views/metele-fiesta');
const distribucion = () => import('@/components/views/distribucion');
const novedades = () => import('@/components/views/novedades');
const promociones = () => import('@/components/views/promociones');
const fichapromocion = () => import('@/components/views/ficha-promocion');
const calidad = () => import('@/components/views/calidad');
const faqs = () => import('@/components/views/faqs');
const categorias = () => import('@/components/views/categorias');
const categoria = () => import('@/components/views/categoria');
const producto = () => import('@/components/views/producto');
const saladeprensa = () => import('@/components/views/sala-de-prensa')
const fichaBaseLegal = () => import('@/components/views/ficha-base-legal')
const alergenos = () => import('@/components/views/alergenos')
import momentoganador from '@/components/views/momento-ganador';
const contactomomentoganador = () => import('@/components/views/contacto-momento-ganador')
const basesmomentoganador = () => import('@/components/views/momento-ganador-bases')

const bebidakojakpower = () => import('@/components/views/bebida-kojak-power');
const callofduty = () => import('@/components/views/call-of-duty');
const callofdutyvanguard = () => import('@/components/views/call-of-duty-vanguard');
const tortugasNinja = () => import('@/components/views/tortugasninja');
const patrullaCanina = () => import('@/components/views/patrullacanina');
const overwatch = () => import("@/components/views/overwatch");
const mapaweb = () => import('@/components/views/mapa-web')
const aviso_legal = () => import('@/components/views/aviso-legal')


const Error404 = () => import('@/components/views/error-404')

const politicaCookies = () => import('@/components/views/politica-de-cookies')
const politicaPrivacidad = () => import('@/components/views/politica-de-privacidad')

Vue.use(Router);


import messages from '@/translations';

let en = messages.en.enlaces;
let es = messages.es.enlaces;

let seo = messages.es.seo

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: `${es.novedades}/:id`,
			alias: `${en.novedades}/:id`,
			name: 'novedades-ficha',
			component: FichaNoticia
		},
		{
			path: `${es.notaprensa}/:id`,
			alias: `${en.notaprensa}/:id`,
			name: 'notaprensa-ficha',
			component: FichaNoticia
		},
		{
			path: `${es.promociones}/:id`,
			alias: `${en.promociones}/:id`,
			name: 'promocion-ficha',
			component: fichapromocion
		},
		{
			path: `${es.base_legal}/:id`,
			alias: `${en.base_legal}/:id`,
			name: 'base-legal-ficha',
			component: fichaBaseLegal
		},
		{
			path: es.fiestahoy,
			alias: en.fiestahoy,
			name: 'fiesta-hoy',
			component: fiestahoy
		},
		{
			path: `${es.productos}`,
			alias: `${en.productos}`,
			name: 'productos-main',
			component: categorias
		},
		{
			path: `${es.productos}/:categoria`,
			alias: `${en.productos}/:categoria`,
			name: 'categoria-main',
			component: categoria
		},
		{
			path: `${es.producto}/:producto/:variante?`,
			alias: `${en.producto}/:producto/:variante?`,
			name: 'producto-main',
			component: producto
		},
		{
			path: `${es.categoria}/:producto/:variante?`,
			alias: `${en.categoria}/:producto/:variante?`,
			name: 'categoria-main',
			component: producto
		},
		{
			path: es.historia,
			alias: en.historia,
			name: 'historia',
			component: historia
		},
		{
			path: es.fiestamundo,
			alias: en.fiestamundo,
			name: 'fiestamundo',
			component: fiestamundo
		},
		{
			path: es.calidad,
			alias: en.calidad,
			name: 'calidad',
			component: calidad
		},
		{
			path: es.novedades,
			alias: en.novedades,
			name: 'novedades',
			component: novedades
		},
		{
			path: es.promociones,
			alias: en.promociones,
			name: 'promociones',
			component: promociones
		},
		{
			path: es.distribucion,
			alias: en.distribucion,
			name: 'distribucion',
			component: distribucion
		},
		{
			path: `${es.metelefiesta}/:id?`,
			alias: en.metelefiesta,
			name: 'metelefiesta',
			component: metelefiesta
		},
		{
			path: es.contacto,
			alias: en.contacto,
			name: 'contacto',
			component: Contacto
		},
		{
			path: es.sala_de_prensa,
			alias: en.sala_de_prensa,
			name: 'saladeprensa',
			component: saladeprensa
		},
		{
			path: es.faqs,
			alias: en.faqs,
			name: 'faqs',
			component: faqs
		},
		{
			path: '/callofduty',
			name: 'cod',
			component: callofduty,
			meta: {
				seo: seo.callofduty,
				image: 'callofduty',
			}
		},
		{
			path: '/callofduty/vanguard',
			name: 'cod',
			component: callofdutyvanguard,
			meta: {
				seo: seo.callofduty,
				image: 'callofduty',
			}
		},
		{
			path: '/tortugasninja',
			name: 'tortujasNinja',
			component: tortugasNinja,
			meta: {
				seo: seo.tortujasNinja,
				image: 'tortujasNinja',
			}
		},
		{
			path: '/patrullacanina',
			name: 'patrullaCanina',
			component: patrullaCanina,
			meta: {
				seo: seo.patrullaCanina,
				image: 'patrullaCanina',
			}
		},
		{
			path: '/overwatch2',
			name: 'overwatch',
			component: overwatch,
			meta: {
				seo: seo.overwatch,
				image: 'patrullaCanina',
			}
		},
		{
			path: '/kojakpower',
			name: 'cod',
			component: bebidakojakpower,
			meta: {
				seo: seo.kojakpower,
				image: 'callofduty',
			}
		},
		{
			path: '/tomarelleno',
			name: 'momento-ganador',
			component: momentoganador,
			meta: {
				seo: seo.momentoganador,
				image: 'momentoganador',
				ganacoche: true
			}
		},
		{
			path: '/promos/ganauncoche/contacto',
			name: 'momento-ganador-contacto',
			component: contactomomentoganador,
			meta: {
				seo: seo.momentoganador,
				image: 'momentoganador',
				ganacoche: true
			}
		},
		{
			path: '/promos/ganauncoche/bases-legales',
			name: 'momento-ganador-bases',
			component: basesmomentoganador,
			meta: {
				seo: seo.momentoganador,
				image: 'momentoganador',
				ganacoche: true
			}
		},
		{
			path: es.trabaja_con_nosotros,
			alias: en.trabaja_con_nosotros,
			name: 'trabaja con nosotros',
			component: TrabajaConNosotros
		},
		{
			path: es.politica_privacidad,
			alias: en.politica_privacidad,
			name: 'politica-de-privacidad',
			component: politicaPrivacidad
		},
		{
			path: es.politica_cookies,
			alias: en.politica_cookies,
			name: 'politica-de-cookies',
			component: politicaCookies
		},
		{
			path: es.mapa_web,
			alias: en.mapa_web,
			name: 'mapa-web',
			component: mapaweb
		},
		{
			path: es.alergeno,
			alias: en.alergeno,
			name: 'alergenos',
			component: alergenos
		},
		{
			path: es.aviso_legal,
			alias: en.aviso_legal,
			name: 'aviso-legal',
			component: aviso_legal
		},
		{ path: '*', redirect: '/' },
		{ path: "/", component: Error404 },
		{ path: "/momento-ganador", redirect: '/promos/ganauncoche' }
	],
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		} else {
			return { x: 0, y: 0 }
		}
	},
});

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
	config: { id: "G-8H4RM3YVMQ" },
	includes: [
		{
			id: 'DC-10432562', params: {
				send_page_view: true
			}
		},
		{
			id: 'AW-427809167', params: {
				send_page_view: true
			}
		},
		{
			id: 'GTM-NK4JCD8',
			params: {
				send_page_view: true
			}
		}
	]
});


router.beforeEach((to, from, next) => {

	if (!!to.meta) {
		if (!!to.meta.seo) {
			document.title = to.meta.seo.title;
			document.head.querySelector("[name=description]").content = to.meta.seo.description;
			document.head.querySelector("[property='og:title']").content = to.meta.seo.title;
			document.head.querySelector("[name='twitter:title']").content = to.meta.seo.title;
			document.head.querySelector("[property='og:description']").content = to.meta.seo.description;
			document.head.querySelector("[name='twitter:description']").content = to.meta.seo.description;
		}

		if (!!to.meta.image) {
			document.head.querySelector("[property='og:image']").content = location.origin + '/static/img/rrss/' + to.meta.image + '.jpg';
			document.head.querySelector("[name='twitter:image']").content = location.origin + '/static/img/rrss/' + to.meta.image + '.jpg';
		}
	}



	next()
});

export default router;




// WEBPACK FOOTER //
// ./src/router/index.js